/**
 * Version and build of this frontend bundle. vite.config.ts fills these in at
 * build time: the version from package.json, the commit from BUILD_COMMIT
 * (Docker build arg), GITHUB_SHA (CI) or the local git checkout.
 * In unit tests they are not set, so every value has a fallback.
 */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION || 'dev';
export const BUILD_COMMIT: string = import.meta.env.VITE_BUILD_COMMIT || '';
export const BUILD_TIME: string = import.meta.env.VITE_BUILD_TIME || '';

/**
 * Short build label, e.g. "9fe2b94 · 19.10.2026, 09:40".
 * Returns null when the commit is unknown.
 */
export function formatBuild(commit?: string | null, time?: string | null, locale?: string): string | null {
  if (!commit) {
    return null;
  }
  const shortCommit = commit.slice(0, 7);
  const date = time ? new Date(time) : null;
  if (!date || Number.isNaN(date.getTime())) {
    return shortCommit;
  }
  const formatted = date.toLocaleString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
  return `${shortCommit} · ${formatted}`;
}
